import React from "react";
import { ICategory, IProductVariant } from "muminsmart-utils";
import {
  getAttributeNameById,
  getAttributeNameByIdFromVariants,
  getSelectedSubSubCategories,
  getVariantAttributes,
  mergeAttributeNameMaps,
  normalizeIds,
} from "./categoryVariantUtils";

export function useCategoryVariantAttributes(
  categories: ICategory[],
  selectedSubSubCategoryIds: string[] | undefined,
  fallbackVariants?: IProductVariant[],
) {
  const normalizedSubSubCategoryIds = React.useMemo(
    () => normalizeIds(selectedSubSubCategoryIds),
    [selectedSubSubCategoryIds],
  );

  const selectedSubSubCategories = React.useMemo(
    () =>
      getSelectedSubSubCategories(categories, normalizedSubSubCategoryIds),
    [categories, normalizedSubSubCategoryIds],
  );

  const variantAttributes = React.useMemo(
    () => getVariantAttributes(selectedSubSubCategories),
    [selectedSubSubCategories],
  );

  const attributeNameById = React.useMemo(
    () =>
      mergeAttributeNameMaps(
        getAttributeNameByIdFromVariants(fallbackVariants),
        getAttributeNameById(selectedSubSubCategories),
      ),
    [fallbackVariants, selectedSubSubCategories],
  );

  return {
    selectedSubSubCategories,
    variantAttributes,
    attributeNameById,
  };
}
